import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import get from 'lodash.get';

import { CardProductTiles } from 'acq-components/lib/composite-components/ProductTiles/CardProductTiles.js';
import { LazyLoad } from 'acq-components/lib/services/performance/LazyLoad/LazyLoad';
import LazyScrollMetricTracker from 'src/universal/components/DTM/LazyScrollMetricTracker';
import { cmComponentPznExt } from 'src/universal/utils/orchestraCmPznExtEvent';
import { isProspect } from 'src/universal/redux/userType';
import { hasMemberInfoArrived } from 'src/universal/redux/cardMemberInfo';
import { ProgressCircle } from 'acq-components/lib/base-components/LoadingIndicator/ProgressCircle/ProgressCircle';
import ProgressCircleStyles from 'acq-components/lib/base-components/LoadingIndicator/ProgressCircle/styles/us-commercial/styles.scss?modules';

import {
  getPdpCrossSellBannerData,
  getPdpCrossSellData,
  getPdpCrossSellDataCM
} from 'page_modules/business-pdp/redux';

import pdpXSellCardTilesStyles from './__styles__/index.scss?modules';

const XSellCardTiles = ({ xSellData = {}, xSellBannerData = {}, needSpinner }) => {
  if (needSpinner) {
    return <ProgressCircle styles={ProgressCircleStyles} />;
  }

  const onMetricTracking = () => {
    if (xSellData.cmExtItems) {
      cmComponentPznExt(xSellData.cmExtItems);
    }
  };

  return (
    <React.Fragment>
      <LazyScrollMetricTracker
        scrollDtm={xSellBannerData.scrollDtm}
        callBackFunction={onMetricTracking}
      />
      <LazyLoad offset={600}>
        <CardProductTiles
          styles={pdpXSellCardTilesStyles}
          qeId="crossSellCardTiles"
          collapsableOnMobile={true}
          {...xSellData}
        />
      </LazyLoad>
    </React.Fragment>
  );
};

const mapStateToProps = (state, ownProps) => {
  const urlEep = get(ownProps, 'params.eep') || '';
  const isUserProspect = isProspect(state);
  const hasCmDataArrived = hasMemberInfoArrived(state);
  const needCardMemberData = !isUserProspect && hasCmDataArrived;
  const needSpinner = !isUserProspect && !hasCmDataArrived;
  const xSellDataVal = needCardMemberData
    ? getPdpCrossSellDataCM(urlEep, pdpXSellCardTilesStyles)(state)
    : getPdpCrossSellData(urlEep, pdpXSellCardTilesStyles)(state);
  return {
    xSellBannerData: getPdpCrossSellBannerData(state),
    xSellData: xSellDataVal,
    needSpinner
  };
};

export default React.memo(withRouter(connect(mapStateToProps)(XSellCardTiles)));
